<template>
  <div id="dashboard-analytics">
    <vs-popup classContent="popup-example" title="Error!!!" :active.sync="genralErrorFlag">
      <div class="modal-body">

        <div>
                      <div class="form-group">
                        <label for="exampleInputEmail1" style="color: #a94442;">{{errorText}}</label>
                      </div>




                    </div>
        <br>
        <vs-button
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container mt-2"
          @click="logOut()"
          type="relief"
          style="float: none !important;"
        >Login Again</vs-button>
  </div>
      </vs-popup>
    <vx-card slot="no-body h-full" class="d-theme-dark-light-bg mb-base">
      <vs-alert :active.sync="errorFlag" closable icon-pack="feather" close-icon="icon-x" color="danger" title="ERROR!!!" style="text-align: center;" @click="dismissError()">
      {{errorText}}
    </vs-alert>
      <div class="vx-row">
        <h1
          class="p-2 font-bold w-full text-primary"
          style="border-bottom: 2px solid;"
        >
          Experian Upload
        </h1>
      </div>
      <div style="text-align: -webkit-center;">
        <div class="vx-col w-full lg:w-1/3">
          <div class="mt-2">
            <template>
              <v-file-input
                v-model="file"
                color="deep-purple accent-4"
                counter

                placeholder="Select your files"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 2"
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                    >{{ text }}</v-chip
                  >

                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ file.length - 2 }} File(s)</span
                  >
                </template>
              </v-file-input>
            </template>
          </div>
        </div>
        <div class="mt-4 vx-col w-full lg:w-1/3" style="text-align: initial;">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click="submitFile()"
            type="relief"
            style="float: none !important;"
            >Submit</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabSelected: 1,
      tablist: [
        { text: "Generate Report", value: 1 },
        { text: "Upload Report", value: 2 },
        { text: "Active Loans", value: 3 },
      ],

              showButton : true,
              file : null,
              errorFlag:false,
              errorText:'',
              errorMessage:'',
              successMessage : '',
              genralErrorFlag:false,
              filteredData:'',
              cityData:'',
              companyNames:'',
              cityNamesComp:'',
              successMessage : '',
              GeneralError:false,
    };
  },
  components: {},
  created() {
    this.$store.commit("routeChange", "start");

    var timestamp = Math.round(+new Date() / 1000);
    var userip = this.$store.getters.ipAddress;
    var data = {

    };
    var msgHeader = {
        authToken: localStorage.getItem('authtoken'), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: userip
    };
    // this.$root.$emit('component1',false);
    var mlGetUnidentifiedUberData = {data, msgHeader};
    const instance = axios.create();

    // Override timeout default for the library
    // Now all requests using this instance will wait 2.5 seconds before timing out

    instance.post('mlExperianUnprocessedData', mlGetUnidentifiedUberData).then((response) => {

        const JSONData = response.data;
        if (JSONData.msgHeader.error == 0) {
            this.$store.commit('setauthtoken', {
                authtoken: JSONData.msgHeader.authToken
            });
            localStorage.setItem('authtoken',JSONData.msgHeader.authToken);



            this.cityData = JSONData.data
            this.companyNames = Object.keys(this.cityData)

            for(var i = 0;i<this.companyNames.length;i++)
            {
            this.cityNamesComp = Object.keys(this.companyNames[i])
            console.log("this are the keys",this.cityNamesComp)
            }
            // console.log("this is experian data",this.companyNames)
            //this.rows = JSONData.data.unidentifiedData;


            //this.rows =  this.data.rows;
            this.$store.commit("routeChange", "end");
            this.$root.$emit('component1' , true);


        }
        else {
          this.errorText = JSONData.data.message;
          if(this.errorText === 'Invalid login' || this.errorText === 'sessionTimeout')
          {
            this.genralErrorFlag = true
          }
          else
          {
              this.errorText = JSONData.data.message;
              this.errorFlag  = true
          }
            this.$store.commit("routeChange", "end");

        }

    })
  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    dismissPop()
    {
      this.GeneralError = false
    },
    logOut:function()
    {
      this.$router.push({
          path: '/',
          query: {},
      });
    },
    submitFile(){
            this.$store.commit("routeChange", "start");
              this.successMessage = '';
              console.log('display file name '+this.file);
              var timestamp = Math.round(+new Date() / 1000);
              var userip = this.$store.getters.ipAddress;
              /*
               Initialize the form data
               */

              let formData = new FormData();

              /*
               Add the form data we need to submit
               */
              formData.append('authLoginID', this.$store.getters.loginId);
              formData.append('ipAddress', userip);
              formData.append('timestamp', timestamp);
              formData.append('authToken', localStorage.getItem('authtoken'));
              formData.append('docType', 'experianBulkUpload');
              formData.append('bulkExperianData', this.file);
              formData.append('format', 'xlsx');
              formData.append('fileType', 'customer');
              this.showButton = false;
              /*
               Make the request to the POST /single-file URL
               */
              const instance = axios.create();


                  // Override timeout default for the library
                  // Now all requests using this instance will wait 2.5 seconds before timing out
              instance.defaults.timeout = 6000000;

              instance.post( 'mlBulkExperianUpload',


                  formData,
                  {
                      headers: {
                          'Content-Type': 'multipart/form-data'
                      }
                  }
              ).then((response) => {
                  console.log('SUCCESS!!');
                  const JSONData = response.data;
                  if (JSONData.data.error == 0) {
                      this.$store.commit('setauthtoken', {
                          authtoken: JSONData.msgHeader.authToken
                      });
                      localStorage.setItem('authtoken',JSONData.msgHeader.authToken);
                      this.successMessage = JSONData.data.message;

                      this.errorText = ""
                      this.callCreated()
                  }
                  else {
                    this.errorText = JSONData.data.message;
                    if(this.errorText === 'Invalid login' || this.errorText === 'sessionTimeout')
                    {
                      this.genralErrorFlag = true
                    }
                    else
                    {
                        this.errorText = JSONData.data.message;
                        this.errorFlag  = true
                    }
                      this.$store.commit("routeChange", "end");

                  }
                this.$store.commit("routeChange", "end");

            })
                .catch(error => {
                    // this.errorText = "Network Error";
                    this.errorText = "Server Connectivity Issue"
                    this.errorFlag  = true

                    this.$store.commit("routeChange", "end");

                  });
          },
          callCreated()
    {

        this.$store.commit("routeChange", "start");
      this.progress = true;
      var timestamp = Math.round(+new Date() / 1000);
      var userip = this.$store.getters.ipAddress;
      var data = {

      };
      var msgHeader = {
          authToken: localStorage.getItem('authtoken'), //dynamic
          authLoginID: this.$store.getters.loginId,
          timestamp: timestamp,
          ipAddress: userip
      };
      // this.$root.$emit('component1',false);
      var mlGetUnidentifiedUberData = {data, msgHeader};
      const instance = axios.create();

      // Override timeout default for the library
      // Now all requests using this instance will wait 2.5 seconds before timing out

      instance.post('mlExperianUnprocessedData', mlGetUnidentifiedUberData).then((response) => {

          const JSONData = response.data;
          if (JSONData.msgHeader.error == 0) {
              this.$store.commit('setauthtoken', {
                  authtoken: JSONData.msgHeader.authToken
              });
              localStorage.setItem('authtoken',JSONData.msgHeader.authToken);



              this.cityData = JSONData.data
              this.companyNames = Object.keys(this.cityData)

              for(var i = 0;i<this.companyNames.length;i++)
              {
              this.cityNamesComp = Object.keys(this.companyNames[i])
              console.log("this are the keys",this.cityNamesComp)
              }
              // console.log("this is experian data",this.companyNames)
              //this.rows = JSONData.data.unidentifiedData;


              //this.rows =  this.data.rows;

              this.$root.$emit('component1' , true);

          }
          else {

            this.errorText = JSONData.data.message;
            if(this.errorText === 'Invalid login' || this.errorText === 'sessionTimeout')
            {
              this.genralErrorFlag = true
            }
            else
            {
                this.errorText = JSONData.data.message;
                this.errorFlag  = true
            }
              this.$store.commit("routeChange", "end");
        }
          this.$store.commit("routeChange", "end");



      })
    },
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
